/*
 * @copyright Copyright (c) valantic CEC Deutschland GmbH (https://www.valantic.com)
 * @see PROJECT_LICENSE.txt
 */

const topSearchIndex = {
    queryPhrase: '',
    sortOptions: [],
    filterOptions: [
        { attribute: 'visibility', in: ['Catalog', 'Catalog, Search'] },
        { attribute: 'inStock', eq: 'true' }
    ],
    liveSearchError: null,
    searchHasRun: false,
    liveSearchProducts: [],
    liveSearchSuggestions: [],
    liveSearchCategories: [],
    init() {
        this.sortOptions = [
            { attribute: 'department', direction: this.getGenderSort() },
            { attribute: 'relevance', direction: 'DESC' }
        ]

        if (typeof this.initHeadingDefaults === 'function') {
            this.initHeadingDefaults()
        }

        this.$nextTick(() => this.enableInput())
    },
    enableInput() {
        this.$refs.searchInput.removeAttribute('disabled')
        this.$refs.searchInput.focus()
    },
    getGenderSort() {
        const genderCookie = hyva.getCookie('mey-gender')
        return (genderCookie === 'm') ? 'DESC' : 'ASC'
    }
}

export default topSearchIndex
